export default __webpack_public_path__ + "static/media/calendar.0dd10f0e.svg";